import React, { useContext } from 'react'
import { ReducerDispatchContext, ReducerContext } from '../reducers/reducerContext.js';
import { fetchSimulationVehicleDetailsIfNeeded, fetchSimulationVehiclesIfNeeded } from '../actions/actionsApiSimulation';
import TestPartExchange from '../components/testCriteria/TestPartExchange';
import { setPartExchange } from '../actions/actionsAppTest';

export default function ContTestPartExchange() {
  const dispatch = useContext(ReducerDispatchContext);
  const globalstate = useContext(ReducerContext);

  function onChangePartExchange(partExchange) {
    dispatch(setPartExchange(partExchange));
    fetchSimulationVehicleDetailsIfNeeded(globalstate, dispatch, {partExchange:partExchange}, null, false);
    fetchSimulationVehiclesIfNeeded(globalstate, dispatch, {partExchange:partExchange}, null, null, null, false);
  }
  return (
    <TestPartExchange
      partExchange={globalstate.testCriteria.partExchange}
      context={globalstate.testCriteria.context}
      env={globalstate.env}
      settings={globalstate.settings}
      onChangePartExchange={onChangePartExchange}
    />
  );
}
